export default "__VITE_ASSET__C7c8kxLx__"